/* esm.sh - @smithy/core@3.24.3/schema */
export * from "/*@smithy/core@3.24.3/esnext/schema.mjs";
